import React, { useState } from "react";
import ImageItem from "../../EngageImages/Type1/ImageItem";
import AdoptionForm from "./AdoptionForm";
import "./Adoption.style.css";
import ReactMarkdown from "react-markdown";
import WebData from "../../../../Helpers/WebData";

const Adoption = () => {
  const [current, setCurrent] = useState(2);

  function showNextCard() {
    if (current < WebData.adoptionCows.names.length - 1) {
      setCurrent(current + 1);
    }
  }

  function showPrevCard() {
    if (current > 0) {
      setCurrent(current - 1);
    }
  }
  const paragraph =
    "In a decade we'd have grown to 86 spanning five generations. There is much of love and playfullness that it stretches our days, and sometimes, the nights!\nWe would really like if you wish to bring some of this love right into your own home. Fill in the information below. Your best friends are waiting for you!\n\nClick here to download the form and after filling, upload it in the section below.\n\n";
  return (
    <>
      <section id="adoptionBanner">
        <div className="row v-adoption-row">
          <div className="col-md-7 adoption-content-wrapper order-last order-md-first content-view">
            <div className=" justify-desc v-adoption physical-adoption adoption-para scrollbar-hide">
              <ReactMarkdown>{paragraph}</ReactMarkdown>
            </div>
            <div className="justify-desc v-adoption physical-adoption adoption-form scrollbar-hide mt-10px">
              <AdoptionForm />
            </div>
          </div>
          <div className="col-md-5 shadow-col image-view ">
            <div className="cards-wrapper">
              <span
                id="right-arrow"
                className={`arrow right fa fa-chevron-right ${
                  current === WebData.adoptionCows.names.length - 1
                    ? "fa-disabled"
                    : ""
                }`}
                onClick={() => showNextCard()}
              ></span>
              <span
                id="left-arrow"
                className={`arrow left fa fa-chevron-left ${
                  current === 0 ? "fa-disabled" : ""
                }`}
                onClick={() => showPrevCard()}
              ></span>
              <ImageItem imageIndex={current} locationFrom="Adoption" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Adoption;
